export default __webpack_public_path__ + "images/logo-databasin.f6426332819afd405401aea2dd0220a0.svg";